import React from 'react'
import {Box, Typography} from '@mui/material'
import {CARD_BORDER_COLOR, CARD_BORDER_RADIUS, NEUTRAL_SCALE} from 'src/theme-new/tokens'

export interface AddressEntry {
  label: string
  value: string
}

interface AddressBoxProps {
  entries: AddressEntry[]
  /** Small uppercase label rendered above the box. Omit when the caller already has its own section title (e.g. an h3 "Indirizzo"). */
  title?: string
}

/**
 * Bordered, "mailing envelope"-ordered address block (via/civico, località, CAP,
 * città, provincia, regione, stato) shared by every read-only detail view that shows
 * a postal address — originally built for the patient's Anagrafica tab, reused as-is
 * by MedicalCenterDetailDialogNew so both look/behave the same way.
 */
export default function AddressBox({entries, title}: AddressBoxProps): JSX.Element | null {
  if (entries.length === 0) return null

  return (
    <>
      {title && (
        <Typography sx={{fontSize: 11, color: NEUTRAL_SCALE[500], mt: 2, mb: 1, textTransform: 'uppercase', letterSpacing: 0.4}}>
          {title}
        </Typography>
      )}
      <Box
        sx={{
          border: `1px solid ${CARD_BORDER_COLOR}`,
          borderRadius: CARD_BORDER_RADIUS,
          p: 2,
          width: '100%',
          display: 'grid',
          gridTemplateColumns: {xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)'},
          columnGap: 3,
          rowGap: 0.5,
        }}
      >
        {entries.map(entry => (
          <Typography key={entry.label} variant="body2">
            <Box component="span" sx={{fontSize: 11, fontWeight: 700, color: NEUTRAL_SCALE[500], textTransform: 'uppercase', letterSpacing: 0.4}}>
              {entry.label}:
            </Box>
            {' '}{entry.value}
          </Typography>
        ))}
      </Box>
    </>
  )
}
